import React from "react";
import OptionsList from "../OptionsList/OptionsList";
import KYCQuestion from "./KYCQuestion";

export default class TypeOfCompany extends KYCQuestion
{
	state = {
		fields: {
			radio_company_form: {
				options: [
					{
						name: "radio_company_form",
						label: "Aktiebolag",
						value: "ab",
						checked: false
					},
					{
						name: "radio_company_form",
						label: "Handelsbolag/Kommanditbolag",
						value: "hbkb",
						checked: false
					},
					{
						name: "radio_company_form",
						label: "Stat/Kommun/Landsting",
						value: "statkom",
						checked: false
					},
					{
						name: "radio_company_form",
						label: "Stiftelse",
						value: "stiftelse",
						checked: false
					},
					{
						name: "radio_company_form",
						label: "Förening",
						value: "forening",
						checked: false
					},
					{
						name: "radio_company_form",
						label: "Förbund",
						value: "forbund",
						checked: false
					},
					{
						name: "radio_company_form",
						label: "Börsbolag i Sverige",
						value: "borsbolag",
						checked: false
					}
				]
			}
		}
	};

	constructor(props, context)
	{
		super(props, context);
		this.fieldName = "radio_company_form";
	}

	render()
	{
		return (
			<React.Fragment>
				<OptionsList
					type="radio"
					name="radio_company_form"
					description="Vilken bolagsform har företaget?"
					orientation="vertical"
					onChange={this._onOptionsListChange}
					options={this.state.fields.radio_company_form.options}
				/>
			</React.Fragment>
		);
	}
}


// WEBPACK FOOTER //
// ./src/routes/Cob/components/KYC/TypeOfCompany.js